/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Company_Profile_Academic_Title_PlaceholderInputs */

const en_company_profile_academic_title_placeholder = /** @type {(inputs: Company_Profile_Academic_Title_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e.g. Bachelor, Master`)
};

const de_company_profile_academic_title_placeholder = /** @type {(inputs: Company_Profile_Academic_Title_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`z.B. Bachelor, Master`)
};

/**
* | output |
* | --- |
* | "e.g. Bachelor, Master" |
*
* @param {Company_Profile_Academic_Title_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const company_profile_academic_title_placeholder = /** @type {((inputs?: Company_Profile_Academic_Title_PlaceholderInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Company_Profile_Academic_Title_PlaceholderInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_company_profile_academic_title_placeholder(inputs)
	return en_company_profile_academic_title_placeholder(inputs)
});